"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createId = void 0;
var tslib_1 = require("tslib");
var uuid_1 = tslib_1.__importDefault(require("uuid"));
var createId = function (maxLength) {
    return uuid_1.default.v4().slice(0, maxLength || 8);
};
exports.createId = createId;
